var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vg-field',_vm._g(_vm._b({attrs:{"label":_vm.label,"value":_vm.projectName,"placeholder":`请选择${_vm.label}`,"disabled":_vm.disabled,"readonly":"","is-link":""},on:{"click":_vm.pick}},'vg-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }